import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { FieldValues } from 'react-hook-form';
import { QuestionnaireQuestion } from '../../components/Questionnaire/types';
import { z } from 'zod';

type Props = {
  questions?: QuestionnaireQuestion[];
  schema?: z.ZodObject<any>;
  answers?: FieldValues;
};

const initialState: Props = {};

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    setOnboardingData(state, action: PayloadAction<Props>) {
      if (!!action.payload) {
        const { questions, schema, answers } = action.payload;
        state.questions = questions;
        state.schema = schema;
        state.answers = answers;
      }
    },
    removeOnboardingData(state) {
      state.answers = {};
    },
  },
});

export const { setOnboardingData, removeOnboardingData } =
  onboardingSlice.actions;

export default onboardingSlice.reducer;
